import { SubNeighborhoodModel } from '../../domain/models/SubNeighborhoodModel';
import { BasicEntity } from './BasicEntity';
import CityEntity from './CityEntity';

export default class SubNeighborhoodEntity extends BasicEntity {
  city: CityEntity = new CityEntity();

  constructor(data?: Partial<SubNeighborhoodEntity>) {
    super(data);
    this.city = new CityEntity(data?.city);
  }

  toDomain(): SubNeighborhoodModel {
    return new SubNeighborhoodModel({
      id: this.id,
      name: this.name,
      city: this.city.toDomain()
    });
  }
}
